import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Spin, Alert, message } from "antd";
import { BASE_URL } from "../../constants/Url";

const PhoneModal = ({
  open,
  setOpen,
  phone,
  setPhone,
  countryCode,
  setCountryCode,
  smsCode,
  setSmsCode,
  handleSendCode,
  handlePhoneContinue,
  loading,
  isAgree,
  setError,
  PhoneInput,
  error,
  countdown,
  t,
  handleClose,
  loadingNew
}) => {
  const [form] = Form.useForm();

  const getPhoneLength = () => {
    switch (String(countryCode)) {
      case "86":
        return 11; // China
      case "852":
        return 8; // Hong Kong
      default:
        return 11;
    }
  };

  const isValidPhone = () => {
    return phone?.length === getPhoneLength();
  };

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [form, open])

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      centered
      title={t("")}
    >
      <Spin spinning={loading}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div className='flex items-center mb-3' style={{ display: 'flex', justifyContent: 'center' }}>
            <img alt='ESI-Logo' role='button' src={BASE_URL + "/logo.svg"} className='esi-logo' />
          </div>
          <p style={{ color: '#888' }}>
            {t("text_leading_online_hair_magazine")}
          </p>
        </div>

        {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}

        <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
          <p className='labelLogin'>{t("Edit Phone Number")}</p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', marginBottom: "30px" }}>
          <p style={{ color: '#888' }}>
            {t("Verify your phone number by entering the OTP sent to your device")}
          </p>
        </div>
        <Form layout="vertical" form={form}>

          {/* PHONE INPUT */}
          <Form.Item name="phone">
            <PhoneInput
              phone={phone}
              setPhone={(val) => {
                setError(null);
                setPhone(val);
              }}
              disabled={countdown > 0}
              countryCode={countryCode} setCountryCode={(val) => {
                setError(null);
                setCountryCode(val)
              }}
              t={t}
            />
          </Form.Item>

          {/* SMS CODE */}
          <Form.Item name="smsCode">
            <Input
              size="large"
              placeholder={t("text_enter_confirm_code")}
              maxLength={6}
              inputMode="numeric"
              pattern="[0-9]*"
              suffix={
                <span
                  role="button"
                  tabIndex={0}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onTouchEnd={(e) => {
                    e.stopPropagation();
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (loadingNew || countdown > 0) return;
                    if (!phone) {
                      message.warning(t("text_enter_phone"));
                      return;
                    }
                    if (!isValidPhone()) {
                      message.warning(t("Please enter a valid phone number and verification code"));
                      return;
                    }
                    handleSendCode();
                  }}
                  style={{
                    color:
                      phone && isValidPhone() && countdown === 0 && !loadingNew
                        ? "#4196ff"
                        : "#999",
                    cursor:
                      countdown > 0 || loadingNew
                        ? "not-allowed"
                        : "pointer",
                    userSelect: "none",
                    padding: "2px 4px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  {loadingNew ? (
                    <Spin size="small" />
                  ) : countdown > 0 ? (
                    `${countdown}s`
                  ) : (
                    t("text_get_code")
                  )}
                </span>
              }
              value={smsCode}
              onChange={(e) => {
                setError(null);
                const value = e.target.value.replace(/\D/g, '');
                setSmsCode(value);
              }}
            />
          </Form.Item>

          {/* SUBMIT BUTTON */}
          <Button
            type="primary"
            size="large"
            block
            onClick={handlePhoneContinue}
            disabled={loading || !phone || !isValidPhone() || !smsCode || smsCode?.length !== 6}
          >
            {loading ? <Spin size="small" /> : t("Save")}
          </Button>

        </Form>
      </Spin>
    </Modal>
  );
};

export default PhoneModal;